import { BaseFieldWidget, DetailM2MTableFieldWidget, ModelFieldType, ReturnPromise, SPI, ViewType } from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: ['aries.platform.promotion.AriesPlatformPromotionPlan', 'aries.platform.promotion.AriesPlatformPromotionReginPlan', 'aries.seller.AriesSellerPromotionPlan'],
    viewName: [
      '品牌推广方案详情_DETAIL_uiView5b14c47ea5764d39bf5217467d7ecd18',
      '区域推广方案详情-复制_DETAIL_uiView06217698d9434006be0b6194efb10df0',
      '区域推广方案详情_DETAIL_uiView82df67137f714a888707bddff566c6c1'
    ],
    viewType: ViewType.Detail,
    ttype: [ModelFieldType.ManyToMany]
  })
)
export class MyFormM2MFieldSelectWidget extends DetailM2MTableFieldWidget {
  protected initSubviewData(): ReturnPromise<void> {
    let currentValues = this.value;
    if (currentValues == null) {
      currentValues = [];
    }
    this.reloadDataSource(currentValues);
  }
}
